import { request } from "../utils/request";
import { AxiosPromise } from "axios";


export const dictionaryApi = {
  findAll: (params?:any):AxiosPromise<any> => request({
    url: '/v1/admin/dictionary',
    params
  }),
  create: (data:any):AxiosPromise<any> => request({
    url: '/v1/admin/dictionary',
    data,
    method: 'post'
  }),
  update: (id:number, data:any):AxiosPromise<any> => request({
    url: `/v1/admin/dictionary/${id}`,
    method: 'patch',
    data
  }),
  delete: (id:number):AxiosPromise<any> => request({
    url: `/v1/admin/dictionary/${id}`,
    method: 'delete'
  }),
}
